import { Link } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';
import Breadcrumb from '../../../../components/layout/Breadcrumb';

// ===== EN Related / Butler Bell — full redesign (mirrors JA; _shared dropped). External URL unchanged. Own FAQ. =====
// Images do not present a portrait claiming to be Yuichi Ishii (face is not the subject).

const points = [
  { title: 'Sharing butler culture', en: 'Communication', desc: 'Through the "Butler Bell" YouTube channel and more, it shares a butler\'s daily work, conduct, and spirit of hospitality.', img: '/images/generated/jba-fs-189-related_butler-bell.webp', alt: 'Sharing a butler\'s daily work and spirit of hospitality' },
  { title: 'Introducing manners and refinement', en: 'Refinement', desc: 'It clearly conveys butler refinement that can be applied in everyday life, from table manners to poise and bearing.', img: '/images/generated/jba-fs-190-related_butler-bell-v6.webp', alt: 'Butler manners and refinement that apply to everyday life' },
  { title: 'Modernizing butler culture', en: 'Modernization', desc: 'It continues to pass the traditional way of the butler on to the next generation through modern media such as video and social platforms.', img: '/images/generated/jba-fs-191-related_butler-bell-v6.webp', alt: 'Carrying tradition to the next generation through modern media' },
];

const faqs = [
  {
    q: 'What is Butler Bell?',
    a: 'Butler Bell is the official brand of Yuichi Ishii, the third chairman of the Japan Butler Association. Drawing on many years of serving clients in Japan and abroad as a butler, it continues to share the true image of a butler and the spirit of hospitality unique to Japan.',
  },
  {
    q: 'What kind of content does it share?',
    a: 'Through the "Butler Bell" YouTube channel and other outlets, it carefully introduces not only the visible side of refined service but also the discipline, conduct, and mindset behind it, offering practical and in-depth content for those who want to learn manners and hospitality.',
  },
  {
    q: 'How is it related to the Japan Butler Association?',
    a: 'Yuichi Ishii, known as Butler Bell, is the third chairman of the Association. Under the ideals the Association upholds, his view of the butler lives on in its training approach. For those who want to study systematically after encountering the world of butlers through video and articles, Japan Butler Academy provides that pathway.',
  },
];

const otherRelated = [
  { name: 'THE BUTLER', role: 'Butler service', to: '/en/related/the-butler' },
  { name: 'Japan Butler Academy', role: 'Training institution', to: '/en/related/butler-academy' },
];

const breadcrumbs = [
  { label: 'Home', href: '/en/' },
  { label: 'Related Sites', href: '/en/related' },
  { label: 'Butler Bell' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.06em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function EnRelatedButlerBellPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/generated/jba-still-typewriter-02.webp" alt="An antique typewriter, a symbol of activities that convey through words" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[700px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Butler Bell</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.02em] mb-6">
              Sharing the image of a butler with society
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.9]">
              The official media brand of Yuichi Ishii, the third chairman of the Japan Butler Association. It shares the true image of a butler and the spirit of hospitality unique to Japan with a wide audience.
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* I. About */}
      <NavyBand no="I" ja="Who is Butler Bell?" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.01em] mb-5">
                The visible side of service, <span className="text-[#a38e65]">and the mindset behind it</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                Butler Bell is the official brand of Yuichi Ishii, the third chairman of the Japan Butler Association. Drawing on many years of serving clients in Japan and abroad as a butler, he continues to share the true image of a butler and the spirit of hospitality unique to Japan with a wide audience.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                Through the "Butler Bell" YouTube channel and other outlets, he carefully introduces not only the visible side of refined service but also the discipline, conduct, and mindset behind it, delivering practical and in-depth content for those who want to learn manners and hospitality or are interested in the butler profession.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9]">
                The work of Butler Bell is also an attempt to retell butler culture in a way that fits modern life. While honoring tradition, it carries the appeal of the butler on to the next generation through contemporary media such as video and social platforms.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-fs-192-related_butler-bell-v8.webp" alt="The quiet, attentive conduct of a butler in daily life" className="w-full h-[300px] sm:h-[400px] md:h-[480px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* II. Highlights */}
      <NavyBand no="II" ja="What Butler Bell does" en="Highlights" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
            {points.map((p) => (
              <article key={p.title} className="flex flex-col bg-white border border-[#e2ddd2] group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative h-52 overflow-hidden">
                  <img src={p.img} alt={p.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                </div>
                <div className="p-7 flex flex-col flex-1 text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1.5">{p.en}</span>
                  <h4 className="jba-display font-medium text-[#1a2942] text-xl mb-3 leading-[1.4]">{p.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{p.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* III. Relationship */}
      <NavyBand no="III" ja="Connection with the Association" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/generated/jba-fs-193-related_butler-bell-v8.webp" alt="The chairman's view of the butler living on in the Association's training" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.01em] mb-6">
                A chairman's view, <span className="text-[#d7b779]">alive in the training</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9] mb-4">
                Yuichi Ishii, known as Butler Bell, is the third chairman of the Japan Butler Association. Under the ideals the Association upholds, his view of the butler lives on in its training approach.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9]">
                The idea of "genuine hospitality" that Butler Bell shares is deeply connected to the conduct and mindset learned at Japan Butler Academy. For those who wish to study systematically after encountering the world of butlers, the Academy provides that pathway.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IV. Official Site */}
      <NavyBand no="IV" ja="Official site" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">Butler Bell official site</h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.9] max-w-2xl mx-auto mb-8">
              For details about Butler Bell's activities and content, please visit the official site.
            </p>
            <a href="https://butlerbell.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              Visit the Butler Bell official site <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* V. FAQ */}
      <NavyBand no="V" ja="Frequently asked questions" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.9] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other related + CTA */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">Other related sites</h3>
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">Interested in learning the butler craft?</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/en/qualifications" className={BTN08_ON_NAVY}>View certifications</Link>
              <Link to="/en/contact" className={BTN08_ON_NAVY}>Contact us</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
